
export default {
  name: 'SpecialSingleCategory',

  props: {
    categories: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    }
  }
}
